import React from 'react'
import { FormContext } from 'react-hook-form'

const ReportFormContextProvider = ({ methods, children }) => {
    return (
        <FormContext {...methods}>
            {children}
        </FormContext>
    )
}

export default ReportFormContextProvider